// The wheel's own pages: Setup, Prizes, Results (156, decision C10).
//
// Shaped like KioskNav, and hung under Wheel in the rail the way Kiosk's pages
// hang under Kiosk. In the address, so a reload keeps the page. Setup and
// Prizes are Nova's; Results is whoever reads People's, so a Viewer sees one
// item here and the rail opens Wheel on it.

import type { ReactNode } from "react";
import type { WheelPanel } from "../routes/route.js";

export type WheelNavProps = {
  readonly panel: WheelPanel;
  readonly onOpen: (panel: WheelPanel) => void;
  readonly className?: string;
  /** Which of the three roleAccess.ts offers this reader. Omitted, all three. */
  readonly offer?: { readonly setup: boolean; readonly prizes: boolean; readonly results: boolean };
};

export const WHEEL_NAV_ITEMS: readonly { readonly panel: WheelPanel; readonly label: string }[] = [
  { panel: "setup", label: "Setup" },
  { panel: "prizes", label: "Prizes" },
  { panel: "results", label: "Results" },
];

export function WheelNav({ panel, onOpen, className, offer }: WheelNavProps): ReactNode {
  const items = WHEEL_NAV_ITEMS.filter((item) => offer === undefined || offer[item.panel]);
  return (
    <nav className={className === undefined ? "seg2" : className} aria-label="Wheel">
      {items.map((item) => (
        <button
          key={item.panel}
          type="button"
          aria-current={item.panel === panel ? "page" : undefined}
          onClick={() => onOpen(item.panel)}
        >
          {item.label}
        </button>
      ))}
    </nav>
  );
}
